export default "__VITE_ASSET__C7eP6LSe__"